import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Autostart } from '@ionic-native/autostart/ngx';
import { Device } from '@ionic-native/device/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Network } from '@ionic-native/network/ngx';
import { AndroidFullScreen } from '@ionic-native/android-full-screen/ngx';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { IonicStorageModule } from '@ionic/storage';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ValidatePageModule } from './pages/validate/validate.module';
import { VendPageModule } from './pages/vend/vend.module';
import { SendPageModule } from './pages/send/send.module';
import { ProductPaymentPageModule } from './pages/product-payment/product-payment.module';
import { ProductSalePageModule } from './pages/product-sale/product-sale.module';
import { HttpConfigInterceptor } from './interceptors/httpConfig.interceptor';
import { GlobalVariables } from './common/global-variables';
import { BatchTransactionsPageModule } from './pages/batch-transactions/batch-transactions.module';

import { BsDropdownModule} from 'ngx-bootstrap/dropdown';
import { NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ValidatePageModule,
    VendPageModule,
    SendPageModule,
    BatchTransactionsPageModule,
    ProductPaymentPageModule,
    ProductSalePageModule,
    IonicStorageModule.forRoot(),
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Autostart,
    Device,
    AppVersion,
    Network,
    AndroidFullScreen,
    BluetoothSerial,
    SocialSharing,
    GoogleAnalytics,
    GlobalVariables,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
